"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBioEditDialog = createBioEditDialog;
var _dialog = require("../../ui/dialog");
var _litHtml = require("lit-html");
require("../../styles/EditDialogs.css");
var _mutations = require("./mutations");
var _rowState = require("../shared/rowState");
var _textUtils = require("../../textUtils");
var _texts = require("../../texts");
function rowHasContent(row) {
  return (0, _textUtils.hasNonEmptyText)(row.description);
}
function toFormState(bioData) {
  const row = {
    description: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(bioData?.description || '')),
    entryNode: (0, _textUtils.toText)(bioData?.entryNode || ''),
    status: (0, _textUtils.toText)(bioData?.entryNode || '') ? 'existing' : 'new'
  };
  return {
    bio: row
  };
}
function renderBioSection(bioRow, onChange) {
  const descriptionName = 'bio-description';
  const descriptionCounterId = 'bio-description-counter';
  const descriptionMaxLength = 2600;
  const descriptionCount = (bioRow?.description || '').length;
  const handleDescriptionInput = event => {
    const target = event.target;
    const nextValue = (0, _textUtils.sanitizeTextValue)(target.value.slice(0, descriptionMaxLength));
    (0, _rowState.applyRowFieldChange)(bioRow, 'description', nextValue, rowHasContent);
    onChange();
  };
  return (0, _litHtml.html)`
    <section class="profile-edit-dialog__section" aria-label="Bio editor">

      <label aria-label="Bio description" class="label profile-edit-dialog__bio-field-container">
        <span class="profile-edit-dialog__field-description">
          You can write about your years of experience, industry, or skills.
          People also talk about their achievements or previous job experiences.
        </span>
        <textarea
          class="profile-edit-dialog__textarea"
          name=${descriptionName}
          rows="5"
          .value=${bioRow?.description || ''}
          maxlength=${descriptionMaxLength}
          aria-describedby=${descriptionCounterId}
          data-contact-field="description"
          data-entry-node=${bioRow?.entryNode || ''}
          data-row-status=${bioRow?.status || 'n/a'}
          placeholder="Write a short bio"
          autocomplete="off"
          @input=${handleDescriptionInput}
        ></textarea>
        <small id=${descriptionCounterId} aria-live="polite">${descriptionCount}/${descriptionMaxLength}</small>
      </label>
    </section>
  `;
}
function renderBioEditTemplate(form, formState, viewerMode) {
  const rerender = () => renderBioEditTemplate(form, formState, viewerMode);
  (0, _litHtml.render)((0, _litHtml.html)`
    ${renderBioSection(formState.bio, rerender)}
    ${viewerMode !== 'owner' ? (0, _litHtml.html)`<p class="profile-edit-dialog__login-message">${_texts.ownerLoginRequiredDialogMessageText}</p>` : null}
  `, form);
}
function createBioEditForm(bioData, viewerMode) {
  const form = document.createElement('form');
  form.classList.add('profile__edit-form', 'profile__edit-form--bio');
  const formState = toFormState(bioData);
  renderBioEditTemplate(form, formState, viewerMode);
  return {
    form,
    formState
  };
}
async function createBioEditDialog(event, store, subject, bioData, viewerMode, onSaved) {
  const dom = event.currentTarget?.ownerDocument || document;
  const {
    form,
    formState
  } = createBioEditForm(bioData, viewerMode);
  const result = await (0, _dialog.openInputDialog)({
    title: _texts.editBioDialogTitleText,
    dom,
    form,
    headerAction: {
      type: 'none'
    },
    submitLabel: _texts.dialogSubmitLabelText,
    cancelLabel: _texts.dialogCancelLabelText,
    shouldCloseWithoutSave: () => {
      const bioOps = (0, _rowState.summarizeRowOps)([formState.bio], rowHasContent);
      return bioOps.create.length === 0 && bioOps.update.length === 0 && bioOps.remove.length === 0;
    },
    validate: () => {
      if (viewerMode !== 'owner') {
        return _texts.ownerLoginRequiredDialogMessageText;
      }
      return null;
    },
    onSave: async () => {
      const bioOps = (0, _rowState.summarizeRowOps)([formState.bio], rowHasContent);
      await (0, _mutations.processBioMutations)(store, subject, bioOps);
    },
    formatSaveError: error => {
      return error instanceof Error ? error.message : _texts.saveBioUpdatesFailedMessageText;
    }
  });
  if (!result) return;
  if (onSaved) {
    await onSaved();
  }
}